export default __webpack_public_path__ + "efe6fcc52f28c575cfde11db054bb4a3.png";